export default {"src":"/_next/static/media/cinnamonroll.b09b6e6e.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};